import { makeAutoObservable } from 'mobx';
import { injectable } from 'tsyringe';

export const TOKEN_ScreenResizeStore = Symbol("ScreenResizeStore");

@injectable()
export default class ScreenResizeStore {
    private readonly MOBILE_BREAKPOINT = 768; // Standard mobile breakpoint in pixels
    private _width: number = 0;
    private _height: number = 0;

    constructor() {
        makeAutoObservable(this);

        // Initialize viewport size
        this.updateDimensions();

        // Subscribe to window resize events
        window.addEventListener('resize', () => {
            this.updateDimensions();
        });
    }

    private updateDimensions = () => {
        this._width = window.innerWidth;
        this._height = window.innerHeight;
    };

    private get isMobileSize(): boolean {
        return this._width < this.MOBILE_BREAKPOINT;
    }

    public get isLargeLandscape(): boolean {
        return !this.isMobileSize && this._width > this._height;
    }

    public get isLargePortrait(): boolean {
        return !this.isMobileSize && this._width <= this._height;
    }

    public get isSmallLandscape(): boolean {
        return this.isMobileSize && this._width > this._height;
    }

    public get isSmallPortrait(): boolean {
        return this.isMobileSize && this._width <= this._height;
    }
}
